import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(public)/j/$referenceNo')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/confirm-job/$referenceNo',
      params: { referenceNo: params.referenceNo },
      search: true,
      replace: true,
    });
  },
  component: () => null,
});
